var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMasterCard1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6751_2755)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1875 19.4678H21.2208V3.21094H12.1875V19.4678Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.76 11.3389C12.76 8.04081 14.3019 5.10341 16.7031 3.21052C14.9469 1.82597 12.7313 1 10.323 1C4.62163 1 0 5.62897 0 11.3389C0 17.0489 4.62163 21.6779 10.323 21.6779C12.7313 21.6779 14.9469 20.8519 16.7031 19.4673C14.3019 17.5742 12.76 14.637 12.76 11.3389Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0839 17.7456V17.3444H32.9792L32.859 17.6204L32.7386 17.3444H32.6339V17.7456H32.7076V17.4429L32.8206 17.704H32.8972L33.0102 17.4423V17.7456H33.0839ZM32.4211 17.7456V17.4128H32.5554V17.345H32.2141V17.4128H32.348V17.7456H32.4211ZM33.4062 11.3389C33.4062 17.0489 28.7843 21.6779 23.0832 21.6779C20.6749 21.6779 18.459 20.8519 16.7031 19.4673C19.1043 17.5745 20.6463 14.637 20.6463 11.3389C20.6463 8.0411 19.1043 5.10369 16.7031 3.21052C18.459 1.82597 20.6749 1 23.0832 1C28.7843 1 33.4062 5.62897 33.4062 11.3389Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6751_2755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard1);
export default __webpack_public_path__ + "static/media/master_card1.1d2d8944242c2102230128c7d8286f0f.svg";
export { ForwardRef as ReactComponent };